import { Box, Paper } from "@mui/material";
import Toolbar from "./toolbar.template";
import { useTheme } from "@mui/material/styles";

export const Layout = ({ title, children, footer, data }) => {
  // Parse query parameters
  const params = new URLSearchParams(window.location.search);
  const theme = useTheme();

  const queryParams = {
    is24HourFormat: params.get("is24HourFormat") || false,
    tempFormat: params.get("format") || "--",
    temperature: Number(params.get("temperature") || "--"),
    weatherIcon: Number(params.get("weatherIcon") || -1),
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
        }}
      >

        <Box
          sx={{
            flexGrow: 1,
            pt: "7.4vh",
            background: theme.palette.background.default,
          }}
          component={Paper}
          square={true}
          elevation={0}
        >
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            {data && children}
          </Box>
        </Box>

        {footer}
      </Box>
    </>
  )
}
